import { generateRandomId } from "../../features/manageCoupons/services/services"
import store from "../store"

export const updateIncentiveData = (data:any)=>{
    store.dispatch({
        type : "updateData",
        payload : data,
    })
}

export const changeIncentiveTab = (value:string )=>{
    store.dispatch({
        type : "updateCurrentTab",
        payload : value,
    })
}

export const updateThresholdErrorMsg = (value:string)=>{
    store.dispatch({
        type : "updateThresholdErrorMsg",
        payload : value
    })
}

export const updateIncentiveValue = (value:any , stateName : string)=>{
    store.dispatch({
        type : "updateValue",
        payload : value,
        stateName : stateName
    })
}

export const resetIncentiveValue = (stateName : any) => {
    store.dispatch({
        type:'resetValue',
        payload:null,
        stateName : stateName
    })
};

export const openComponent = (stateName : any) => {
    store.dispatch({
        type:'updateIsOpen',
        payload:true,
        stateName : stateName
    })
};


export const updateIsValid = (isValid:boolean, stateName:string) => {
    store.dispatch({
        type:'updateIsValid',
        payload:isValid,
        stateName : stateName
    })
};

 export const updateIncentiveSummaryData = (value : any) =>{
    store.dispatch({
        type : "updateIncentiveSummaryData",
        payload : value
    })
 }

 export const resetIncentiveState = (value : any) =>{
    store.dispatch({
        type : "reset_data",
        payload : true
    })
 }

// export const closeComponent = (stateName:string)=>{
//     const pageData = store.getState().manageIncentive?.data
//     let newData = data;
//     store.dispatch({
//         type : "updateUserSelection",
//         payload : [...userSelection,{...newData,id:generateRandomId()}]
//     })
// }
// export const resetComponent = (stateName:string)=>{
//     const {userSelection} = store.getState().manageIncentive?.data
//     let newData = data;
//     store.dispatch({
//         type : "updateUserSelection",
//         payload : [...userSelection,{...newData,id:generateRandomId()}]
//     })
// }



